export enum Endpoints {
  BLOG = 'https://api.openup.pte.hu/api/v1/blog/',
  TUTORIAL = 'https://api.openup.pte.hu/api/v1/tutorial/',
  DEMO = 'https://api.openup.pte.hu/api/v1/demo/',
}
